import type { FontFamily, LabeledOption, Nullable } from '@iheartjane/types';

export const toLabeledFontOption = (
  font?: Nullable<FontFamily>
): Nullable<LabeledOption> =>
  font
    ? {
        label: font.font_family,
        value: font.font_family,
      }
    : null;

export const bloomFontFamilyFromGoogleFontName = (
  googleFontFamilyName: string
): FontFamily => {
  /** @see https://developers.google.com/fonts/docs/getting_started#specifying_font_families_and_styles_in_a_stylesheet_url */
  const styleSheetUrl = `https://fonts.googleapis.com/css?${new URLSearchParams(
    {
      family: `${googleFontFamilyName}:r,b`,
      display: 'swap',
    }
  ).toString()}`;

  return { font_family: googleFontFamilyName, url: styleSheetUrl };
};

/**
 * A font the operator imported themselves rather than picked from Google Fonts.
 * Google-picked fonts always carry the stylesheet URL we build for them above.
 */
export const isCustomFontFamily = (
  font?: Nullable<FontFamily>
): font is FontFamily =>
  Boolean(font?.url && !font.url.startsWith('https://fonts.googleapis.com/'));
